import module from 'fanconsultores/module.js'
import template from './template.html'

class FanconsultoresAdminSesionComponent {
  constructor ($timeout, $session) {
    this.$timeout = $timeout
    this.$session = $session
    this.token = null
    this.alarma = 60
    this.sesion_alarma = null
    this.alarmTimer = null
    this.expiresTimer = null
  }

  $onChanges (changes) {
    if (changes.token) {
      this.$timeout.cancel(this.alarmTimer)
      this.$timeout.cancel(this.expiresTimer)

      this.sesion_alarma = null

      if (changes.token.currentValue) {
        this.actualizarSesion()
      }
    }
  }

  actualizarSesion () {
    const tiempo = (new Date()).getTime()
    const expiracion = new Date(this.token.exp * 1000)
    const alarmaPrevia = new Date((this.token.exp - this.alarma) * 1000).getTime() - tiempo
    const alarmaFinal = expiracion.getTime() - tiempo

    if (expiracion.getTime() > tiempo) {
      this.alarmTimer = this.$timeout(() => (this.sesion_alarma = expiracion), alarmaPrevia)
      this.expiresTimer = this.$timeout(() => (this.$session.unauth()), alarmaFinal)
    }
  }
}

module.component('fanconsultoresAdminSesion', {
  controller: FanconsultoresAdminSesionComponent,
  template,
  bindings: {
    token: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fanconsultores/components/fanconsultores/admin/sesion/component.js